/** "2026-09" -> "September 2026". Anything else is returned unchanged. */
export function formatMonth(month: string): string {
  const match = /^(\d{4})-(\d{2})$/.exec(month);
  if (!match) return month;
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 15));
  if (Number.isNaN(date.getTime()) || Number(match[2]) < 1 || Number(match[2]) > 12) return month;
  return new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(date);
}

/**
 * Sign-in return targets must stay on our site, so the sign-in page cannot be
 * used to bounce people elsewhere. Allowed: a path on this host, or an
 * http(s) URL on `siteDomain` or one of its subdomains (the play host).
 */
export function safeReturnTo(value: string | null | undefined, fallback = '/', siteDomain?: string): string {
  if (!value) return fallback;
  const trimmed = value.trim();
  if (/[\u0000-\u001f\\]/.test(trimmed)) return fallback;
  if (trimmed.startsWith('/')) return trimmed.startsWith('//') ? fallback : trimmed;
  if (!siteDomain) return fallback;
  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    return fallback;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return fallback;
  if (url.username || url.password) return fallback;
  const host = url.hostname.toLowerCase();
  const domain = siteDomain.toLowerCase().replace(/^www\./, '');
  return host === domain || host.endsWith(`.${domain}`) ? url.toString() : fallback;
}
